import Form from './Form';
// eslint-disable-next-line import/no-cycle
import Header from './Header';
import Sections from './Sections';
import Table from './Table';
import { METHOD_OPTIONS, THEME_COLOR } from './constants';
import { CalculatorSection, DensityCalculatorContainer, RadioGroup } from './styles';
import useDensityCalculator from './useDensityCalculator';
import RadioButton from '../../ComponentLibrary/input-elements/oc-radio-button';

// eslint-disable-next-line react/prop-types
export const DensityCalculator = ({ header, displacementSections = [], caliperSections = [] }) => {
  const { method, setMethod, formInputs, handleInputChange, onCalculate, results } = useDensityCalculator();

  const changeMethod = e => {
    if (e.target.checked) {
      setMethod(e.target.value);
    }
  };

  const sections = method === 'displacement' ? displacementSections : caliperSections;

  return (
    <DensityCalculatorContainer>
      <Header copy={header} />
      <RadioGroup>
        {METHOD_OPTIONS.map(option => (
          <RadioButton
            data-checked={method === option.value}
            key={option.value}
            themeColor={THEME_COLOR}
            name="density-calculator-choice"
            checked={method === option.value}
            value={option.value}
            onChange={changeMethod}
          >
            {option.text}
          </RadioButton>
        ))}
      </RadioGroup>
      {sections && <Sections sections={sections} />}
      <CalculatorSection>
        <Form
          method={method}
          themeColor={THEME_COLOR}
          formInputs={formInputs}
          handleInputChange={handleInputChange}
          onCalculate={onCalculate}
        />
        <Table method={method} results={results} />
      </CalculatorSection>
    </DensityCalculatorContainer>
  );
};

export default DensityCalculator;
